import { FaCheckCircle, FaTimesCircle } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import LoadingSpinner from '../../../Components/Components/LoadingSpinner';
import { usePayment } from '../../../Providers/PaymentProvider';
import { useEffect, useState } from 'react';
import ErrorBoundary from '../../../Components/ErrorBoundary/ErrorBoundary';
import { useAuth } from '../../../Providers/AuthProvider';


const PaymentSummary = ({ paymentOrderIdParam, paymentHash, sessionId, paymentLink }) => {
    const navigate = useNavigate()
    const { handleGetPaymentData, handleCollectElavonPaymentStatus, handleChangeTaskStatusIfNeeded } = usePayment()
    const [paymentType, setPaymentType] = useState(paymentOrderIdParam && paymentHash ? 'AutoPay' : 'Elavon')
    const [paymentOrderId, setPaymentOrderId] = useState(paymentType == 'AutoPay' ? paymentOrderIdParam : paymentLink)
    const { authState } = useAuth();

    const [isOrder, setIsOrder] = useState(true)
    const [isCreditLimit, setIsCreditLimit] = useState(true)
    const [paymentStatus, setPaymentStatus] = useState(1)//1-pending 2-success 3-failed 99-błąd techniczny w pobieraniu
    const [transactionId, setTransactionId] = useState('Pobieranie...')

    useEffect(() => {
        const startsWithCustId = transactionId.startsWith(authState.custId)
        setIsCreditLimit(startsWithCustId)
        const startsWithDigit = /^\d/.test(transactionId)
        setIsOrder(startsWithDigit)
    }, [transactionId])

    const checkPaymentStatus = async () => {
        if (paymentStatus == 1) {
            if (paymentType == 'AutoPay') {
                const paymentData = await handleGetPaymentData(paymentOrderId)
                if (paymentData) {
                    setPaymentStatus(paymentData.paymentStatus)
                    setTransactionId(paymentData.transactionId)
                } else {
                    setPaymentStatus(99)
                    setTransactionId('Pobieranie...')
                }
            }
            else {
                await handleChangeTaskStatusIfNeeded(paymentLink) //aktualizacja taskLoga
                const paymentData = await handleCollectElavonPaymentStatus(paymentLink)
                if (paymentData) {
                    setPaymentStatus(paymentData.paymentStatus)
                    setTransactionId(paymentData.transactionId)
                } else {
                    setPaymentStatus(99)
                    setTransactionId('Pobieranie...')
                }
            }
        }
    }

    useEffect(() => {
        checkPaymentStatus()
        const intervalId = setInterval(checkPaymentStatus, 5000) //5sek
        return () => clearInterval(intervalId)
    }, [paymentStatus])

    const getNavigationButton = (name, isPrimaryStyle) => {
        let buttonStyle = isPrimaryStyle ? 'btn-app-primary' : 'btn-app-secondary'
        switch (name) {
            case 'shop':
                return <button className={buttonStyle} onClick={() => navigate('/shop', { replace: true })}>Wróć do sklepu</button>
            case 'finances':
                return <button className={buttonStyle} onClick={() => navigate('/Finances', { replace: true })}>Moje Finanse</button>
            case 'orders':
                return <button className={buttonStyle} onClick={() => navigate('/Orders', { replace: true })}>Moje zamówienia</button>
            case 'creditLimit':
                return <button className={buttonStyle} onClick={() => navigate('/MyAccount', { replace: true })}>Moje konto</button>
            default:
                return <button className={buttonStyle} onClick={() => navigate('/shop', { replace: true })}>Wróć do sklepu</button>
        }
    }

    let textVisibility = isOrder ? '' : 'd-none'

    const renderSuccess = () => {
        return (<div className="text-center py-5">
            <div className="mb-4">
                <FaCheckCircle size={80} color="var(--success-color)" />
            </div>
            <h2 className="mb-3">{isCreditLimit ? 'Dziękujemy za opłacenie limitu kredytowego!' : isOrder ? 'Dziękujemy za opłacenie zamówienia!' : 'Dziękujemy za opłacenie dokumentu!'}</h2>
            <p className="lead">Twoja płatność została pomyślnie zweryfikowana.</p>

            <div className="card d-inline-block p-4 my-3 bg-light border-0 shadow-sm" style={{ minWidth: '300px' }}>
                <p className="mb-1 text-muted">{isCreditLimit ? 'Numer transakcji:' : isOrder ? 'Numer zamówienia:' : 'Numer dokumentu:'}</p>
                <h4 className="fw-bold">{isCreditLimit ? transactionId.replace('-', '/') : isOrder ? transactionId.replace('-', '/') : transactionId.replace('-', '/').replace('-', '/')}</h4>
                <p className="mb-1 text-muted">Identyfikator transakcji</p>
                <h4 className="fw-bold">{paymentOrderId.toUpperCase()}</h4>
            </div>

            <div className='text-muted d-flex flex-column mt-2 mb-4'>
                <span>Potwierdzenie wysłaliśmy na Twój adres e-mail.</span>
                <span className={textVisibility}>Zamówienie zostanie wkrótce zrealizowane.</span>
            </div>

            <div className="d-flex justify-content-center gap-3">
                {getNavigationButton(isCreditLimit ? 'creditLimit' : isOrder ? 'orders' : 'finances', false)}
                {getNavigationButton('shop', true)}
            </div>
        </div>)
    }

    const renderError = () => {
        return (<div className="text-center py-5">
            <div className="mb-4">
                <FaTimesCircle size={80} color="var(--error-color)" />
            </div>
            <h2>Płatność nieudana</h2>
            <div className="card d-inline-block p-4 my-3 bg-light border-0 shadow-sm" style={{ minWidth: '300px' }}>
                <p className="mb-1 text-muted">{isCreditLimit ? 'Numer transakcji:' : isOrder ? 'Numer zamówienia:' : 'Numer dokumentu:'}</p>
                <h4 className="fw-bold">{isCreditLimit ? transactionId.replace('-', '/') : isOrder ? transactionId.replace('-', '/') : transactionId.replace('-', '/').replace('-', '/')}</h4>
                <p className="mb-1 text-muted">Identyfikator transakcji</p>
                <h4 className="fw-bold">{paymentOrderId.toUpperCase()}</h4>
            </div>
            <p>{isCreditLimit ? 'Spróbuj ponownie opłacić limit kredytowy lub skontaktuj się z nami.' : isOrder ? 'Spróbuj ponownie opłacić zamówienie lub skontaktuj się z nami.' : 'Spróbuj ponownie opłacić dokument lub skontaktuj się z nami.'}</p>
            <p className="error-text-color">Nie mogliśmy potwierdzić Twojej płatności lub została ona anulowana.</p>
            <div className="d-flex justify-content-center gap-3">
                {getNavigationButton(isCreditLimit ? 'creditLimit' : isOrder ? 'orders' : 'finances', false)}
                {getNavigationButton('shop', true)}
            </div>
        </div>)
    }

    const renderInternalError = () => {
        return (<div className="text-center py-5">
            <div className="mb-4">
                <FaTimesCircle size={80} color="var(--error-color)" />
            </div>
            <h2 className='error-text-color'>Problem techniczny z pobieraniem statusu płatności!</h2>
            <div className="card d-inline-block p-4 my-3 bg-light border-0 shadow-sm" style={{ minWidth: '300px' }}>
                <p className="mb-1 text-muted">Identyfikator transakcji</p>
                <h4 className="fw-bold">{paymentOrderId.toUpperCase()}</h4>
            </div>
            <p>Spróbój odświeżyć stronę za chwilę, jeżeli problem nadal występuje skontaktuj się z administratorem strony!</p>
            <p className="error-text-color">Nie mogliśmy pobrać statusu twojej płatności.</p>
            <button className='btn-app-primary mb-3' onClick={() => window.location.reload()}>Odśwież strone</button>
            <div className="d-flex justify-content-center gap-3">
                {getNavigationButton(isCreditLimit ? 'creditLimit' : isOrder ? 'orders' : 'finances', false)}
                {getNavigationButton('shop', true)}
            </div>
        </div>)
    }

    const renderLoading = () => {
        return (<div className="text-center py-5">
            <LoadingSpinner />
            <h3>Oczekujemy na twoją płatność...</h3>
            <p className="text-muted">Jeżeli tego nie zrobiłeś dokończ finalizację płatności.</p>
            <div className="card d-inline-block p-4 my-3 bg-light border-0 shadow-sm" style={{ minWidth: '300px' }}>
                <p className="mb-1 text-muted">{isCreditLimit ? 'Numer transakcji:' : isOrder ? 'Numer zamówienia:' : 'Numer dokumentu:'}</p>
                <h4 className="fw-bold">{isCreditLimit ? transactionId.replace('-', '/') : isOrder ? transactionId.replace('-', '/') : transactionId.replace('-', '/').replace('-', '/')}</h4>
                <p className="mb-1 text-muted">Identyfikator transakcji</p>
                <h4 className="fw-bold">{paymentOrderId.toUpperCase()}</h4>
            </div>
        </div>)
    }

    const mainrenderFunc = () => {
        try {
            switch (paymentStatus) {
                case 1:
                    return renderLoading()
                case 2:
                    return renderSuccess()
                case 3:
                    return renderError()
                case 99:
                    return renderInternalError()
                default:
                    return renderLoading()
            }
        }
        catch (e) {
            console.log(e)
            return renderInternalError()
        }
    }

    return (
        <ErrorBoundary>
            <div className="container mt-5">
                <div className="row justify-content-center">
                    <div className="col-md-8 col-lg-6">
                        <div className="card shadow-lg border-0 rounded-3">
                            <div className="card-body">
                                {mainrenderFunc()}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ErrorBoundary>
    )
}

export default PaymentSummary